import Error from '../../model/Error';
import VacationRequest from '../../dto/federation/VacationRequest';
import axios from 'axios';

export default class VacationRequestRepository {
    static findByFederationId(federationId, lastEditedOnly) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/vacation-requests?lastEditedOnly=${lastEditedOnly}`)
                .then((response) => resolve(response.data.data.map((data) => VacationRequest.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(federationId, vacationRequestId, approved) {
        const data = { approved };
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/vacation-requests/${vacationRequestId}`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
